import React, { useEffect, useState, useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";

import {
  COMMON_SERVICES,
  headersConfigData,
} from "redux/reduxToolkitServices/_commonServices/commonServices";
import moment from "moment";
import "@progress/kendo-theme-default/dist/all.css";
import { useHookstate } from "@hookstate/core";
import { Box } from "@mui/system";
import { PopUpContainer } from "assets/css/globle";

import {
  FLEET_GLOBAL_STATES,
  MESSAGE_FLEET_GLOBAL_STATES,
  UPDATED_CAR_DATA_STATE,
  LIST_BY_GLOBAL_STATES
} from "globalStore/globalStore";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { API_CALLS } from "./../../../redux/reduxToolkitServices/_commonApiCalls/api";
import {
  Chart,
  ChartSeries,
  ChartArea,
  ChartTooltip,
  ChartSeriesItem,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartTitle,
  ChartValueAxis,
  ChartValueAxisItem,
  ChartLegend,
  ChartSeriesDefaults,
} from "@progress/kendo-react-charts";
import "hammerjs";
import { CarDetails } from "commonComponents/CarDetails";
import { Checkbox, Modal } from "@mui/material";
import { CircleBtn } from "assets/css/globle";
import {
  UsageContainer,
  ChartRow,
  Wrapper,
  SortingHeader,
} from "pages/Fleet/Usage/UsageStyled";
import { Loader } from "commonComponents/Loader/Loader";
import { API_STATUSES } from "redux/_helpers/statuses";

import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { MsgToSelectedCarsCmp } from "commonComponents/SideNav/subSectionNav/Map/commonFunctionalities/MsgToSelectedCars";
import { useTranslation } from "react-i18next";
import FormControlLabel from "@mui/material/FormControlLabel";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import Tooltip from "@mui/material/Tooltip";
import CheckIcon from "assets/svgIcons/CheckIcon";
import { getFeatureSetOption, isUserAdmin, isUserSupport,getFeaturesList } from "constant";
import { getUserRole } from "redux/reduxToolkitServices/_commonReducers/commonReducers";

const UsageReport = React.memo(() => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [odometerZeroFilter, setOdometerZeroFilter] = useState(true);
  const [WattPerMilesZeroFilter, setWattPerMilesZeroFilter] = useState(true);
  const [KWHoursZeroFilter, setKWHoursZeroFilter] = useState(true);
  const [AmpHoursZeroFilter, setAmpHoursZeroFilter] = useState(true);
  const [AHPerMilesZeroFilter, setAHPerMilesZeroFilter] = useState(true);
  const [domRender, setDomRender] = useState(false);
  const [TempCarObj, setTempCarObj] = useState(null);
  const [getCarUsageDetailTempState, setCarUsageDetailTempState] =
    useState(null);
  const [getRoundsByCarTempDetailState, setRoundsByCarTempDetailState] =
    useState(null);
  const [startDate, setStartDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const {
    memberCar,
} = useHookstate(LIST_BY_GLOBAL_STATES);
  const [open, setOpen] = useState(false);
  const [MtdState, setMtdState] = useState(false);
  const [openCarNotFound, setOpenCarNotFound] = React.useState(false);
  const [clickedCarNumber, setClickedCarNumber] = React.useState(false);
  const [QtdState, setQtdState] = useState(false);
  const [YTDState, setYTDState] = useState(false);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { isLoading } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);
  const { roundStateGlobal, holeStateGlobal, gpsCardIdStateData } =
    useHookstate(FLEET_GLOBAL_STATES);
  const [RoundHoleRefreshChart, setRoundHoleRefreshChart] = useState(true);
  const [AMPHoursPerMilesRefreshChart, setAMPHoursPerMilesRefreshChart] =
    useState(true);
  const [AMPHoursRefreshChart, setAMPHoursRefreshChart] = useState(true);
  const [OdometerRefreshChart, setOdometerRefreshChart] = useState(true);
  const [KWPerMilesRefreshChart, setKWPerMilesRefreshChart] = useState(true);
  const [KWHoursRefreshChart, setKWHoursRefreshChart] = useState(true);
  const [rangeHighAmpHours, setRangeHighAmpHours] = useState(null);
  const [rangeLowAmpHours, setRangeLowAmpHours] = useState(null);
  const [minAmpGraph, setMinAmpGraph] = useState(0);
  const [maxAmpGraph, setMaxAmpGraph] = useState(0);
  const [ampHourAvgArrays, setAmpHourAvgArrays] = useState([]);

  const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);
  const {
    getCarsData,
    getCurrentCarsData,
    getMessagesFromCarsData,
    getFaultsData,
    siteSettingsData,
    getRoundsByCarDetailState,
    getCarUsageDetailState,
    getCarUsageDetailStatus,
    getRoundsByCarState,
    getRoundsByCarStatus,
    siteSettingDataReduxStateStatus,
  } = useSelector((state) => state.commonReducers) || "";

  const filterH = useRef(null);
  //-------filter height ---------------
  useEffect(() => {
    if (filterH.current?.clientHeight === null) {
      return;
    }
  });

  const [includeMemberCars, setIncludeMemberCars] = useState(false);
  let useKMInstead = false;
  const showMonthlyData = () => {
    setMtdState(true);
    setQtdState(false);
    setYTDState(false);
    setStartDate(moment().set("date", 1).format("YYYY-MM-DD"));
    setEndDate(moment(new Date()).format("YYYY-MM-DD"));
  };
  const { setMsgToSingleCar } = useHookstate(FLEET_GLOBAL_STATES);
  const isMemberCar = isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) || !getFeatureSetOption(
              siteSettingsData?.Features,
              getFeaturesList().member_cars
          );
  useEffect(() => {
    if (siteId.get() !== null) {
      let startDates = moment(new Date()).format("YYYY-MM-DD");
      startDates = moment().set("date", 1).format("YYYY-MM-DD");

      dispatch(
        COMMON_SERVICES.getRoundsByCarDetailServices(
          siteId.get(),
          startDates.toString(),
          endDate.toString(),
          includeMemberCars
        )
      );

      dispatch(
        COMMON_SERVICES.getCarUsageDetailServices(
          siteId.get(),
          includeMemberCars
        )
      );

      dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
      dispatch(
        COMMON_SERVICES.getExportUsageServices(
          siteId.get(),
          includeMemberCars,
          useKMInstead
        )
      );
    }
  }, [siteId.get(), includeMemberCars]);

  useEffect(() => {
    let isApisubscribed = true;
    if (siteId.get() !== null) {
      if (isApisubscribed) {
        dispatch(
          COMMON_SERVICES.getCarUsageDetailServices(
            siteId.get(),
            includeMemberCars
          )
        );
        dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
        dispatch(
          COMMON_SERVICES.getExportUsageServices(
            siteId.get(),
            includeMemberCars,
            useKMInstead
          )
        );
      }

      showMonthlyData();
      getCarUsageDetailState &&
        getCarUsageDetailState !== undefined &&
        setCarUsageDetailTempState(getCarUsageDetailState);
      getRoundsByCarDetailState &&
        getRoundsByCarDetailState !== undefined &&
        setRoundsByCarTempDetailState(getRoundsByCarDetailState);
    }

    return () => {
      isApisubscribed = false;
    };
  }, [siteId.get(), includeMemberCars]);
  useEffect(() => {
    setRoundHoleRefreshChart(true);
    setTimeout(() => setRoundHoleRefreshChart(false), 2000);
  }, [
    holeStateGlobal.get(),
    roundStateGlobal.get(),
    QtdState,
    MtdState,
    YTDState,
  ]);

  useEffect(() => {
    setRoundHoleRefreshChart(true);
    setAMPHoursPerMilesRefreshChart(true);
    setAMPHoursRefreshChart(true);
    setOdometerRefreshChart(true);
    setKWPerMilesRefreshChart(true);
    setKWHoursRefreshChart(true);
  }, [
    getCarUsageDetailStatus === "success",
    getRoundsByCarStatus === "success",
  ]);

  useEffect(() => {
    setRoundHoleRefreshChart(false);
    setAMPHoursPerMilesRefreshChart(false);
    setAMPHoursRefreshChart(false);
    setOdometerRefreshChart(false);
    setKWPerMilesRefreshChart(false);
    setKWHoursRefreshChart(false);
  }, [getCarsData, getCurrentCarsData, getMessagesFromCarsData, getFaultsData]);

  useEffect(() => {
    let isApisubscribed = true;
    if (siteId.get() !== null && siteId.get() === null) {
      if (isApisubscribed) {
        dispatch(
          COMMON_SERVICES.getRoundsByCarDetailServices(
            siteId.get(),
            startDate.toString(),
            endDate.toString(),
            includeMemberCars
          )
        );
      }
    }

    return () => {
      isApisubscribed = false;
    };
  }, [siteId.get(), startDate, endDate, dispatch, includeMemberCars]);

  useEffect(() => {
    setDomRender(!domRender);
    setRoundHoleRefreshChart(true);
    setTimeout(() => setRoundHoleRefreshChart(false), 2000);
  }, [getRoundsByCarTempDetailState]);

  useEffect(() => {
    if (updatedCarData.get() && updatedCarData.get().length !== 0) {
      let carData = JSON.parse(updatedCarData.get());
      if (carData && Array.isArray(carData) && carData.length !== 0) {
        const carObjData = carData.filter(
          (item) => item?.Car?.GpsiCarId === gpsCardIdStateData.get()
        );
        setTempCarObj(carObjData[0]);
      }
    } else {
      setTempCarObj(null);
    }
  }, [updatedCarData.get()]);

  const ampHoursData =
    getCarUsageDetailState &&
    getCarUsageDetailState !== null &&
    getCarUsageDetailState.CarUsage?.map((item) => {
      var datum = {
        AmpHours: item.AmpHours,
        Odometer: item.Odometer,
        WattHoursPerMile: item.WattHoursPerMile,
        KiloWattHours: item.KiloWattHours,
        AmpHoursPerMile: item.AmpHoursPerMile,
        GpsiCarId: item.GpsiCarId,
        CarNumber: item.CarNumber,
      };
      return datum;
    });

  const ampHoursZeroFilterData =
    ampHoursData && ampHoursData.filter((item) => item.AmpHours !== 0);
  const aHPerMileZeroFilterData =
    ampHoursData && ampHoursData.filter((item) => item.AmpHoursPerMile !== 0);
  const OdometerChartZeroFilterData =
    ampHoursData && ampHoursData.filter((item) => item.Odometer !== 0);
  const KWHoursChartZeroFilterData =
    ampHoursData && ampHoursData.filter((item) => item.KiloWattHours !== 0);
  const WattHoursPerMileChartZeroFilterData =
    ampHoursData && ampHoursData.filter((item) => item.WattHoursPerMile !== 0);

  const ampHoursAverageData =
    getCarUsageDetailState &&
    getCarUsageDetailState !== undefined &&
    getCarUsageDetailState !== null &&
    getCarUsageDetailState?.CarUsage?.map((index) =>
      AmpHoursZeroFilter
        ? getCarUsageDetailState?.AverageAmpHoursDetails?.Average
        : getCarUsageDetailState?.AverageAmpHoursDetailsIncludesZero?.Average
    );

  const roundAverageData =
    getRoundsByCarDetailState &&
    getRoundsByCarDetailState !== undefined &&
    getRoundsByCarDetailState !== null &&
    getRoundsByCarDetailState?.CarRounds?.map(
      (index) => getRoundsByCarDetailState?.AverageRoundDetails?.Average
    );

  const holeAverageData =
    getRoundsByCarDetailState &&
    getRoundsByCarDetailState !== undefined &&
    getRoundsByCarDetailState !== null &&
    getRoundsByCarDetailState?.CarRounds?.map(
      (index) => getRoundsByCarDetailState?.AverageHoleDetails?.Average
    );

  const AHPerMileAverageData =
    getCarUsageDetailState &&
    getCarUsageDetailState !== undefined &&
    getCarUsageDetailState !== null &&
    getCarUsageDetailState?.CarUsage?.map((index) =>
      AHPerMilesZeroFilter
        ? getCarUsageDetailState?.AverageAmpHoursPerMileDetails?.Average
        : getCarUsageDetailState?.AverageAmpHoursPerMileDetailsIncludesZero
          ?.Average
    );

  const kwHoursAverageData =
    getCarUsageDetailState &&
    getCarUsageDetailState !== undefined &&
    getCarUsageDetailState !== null &&
    getCarUsageDetailState?.CarUsage?.map((index) =>
      KWHoursZeroFilter
        ? getCarUsageDetailState?.AverageKiloWattHoursDetails?.Average
        : getCarUsageDetailState?.AverageKiloWattHoursDetailsIncludesZero
          ?.Average
    );

  const WattHourPerMilesAverageData =
    getCarUsageDetailState &&
    getCarUsageDetailState !== undefined &&
    getCarUsageDetailState !== null &&
    getCarUsageDetailState?.CarUsage?.map((index) =>
      WattPerMilesZeroFilter
        ? getCarUsageDetailState?.AverageWattHoursPerMileDetails?.Average
        : getCarUsageDetailState?.AverageWattHoursPerMileDetailsIncludesZero
          ?.Average
    );

  const odometerAverageData =
    getCarUsageDetailState &&
    getCarUsageDetailState !== undefined &&
    getCarUsageDetailState !== null &&
    getCarUsageDetailState?.CarUsage?.map((index) =>
      odometerZeroFilter
        ? getCarUsageDetailState?.AverageOdometerDetails?.Average
        : getCarUsageDetailState?.AverageOdometerDetailsIncludesZero?.Average
    );

  let filterRoundData = [];
  let filterHolesData = [];
  let filterRoundRow = {};
  if (getRoundsByCarState && getRoundsByCarState.length > 0) {
    for (let i = 0; i < getRoundsByCarState.length; i++) {
      if (getRoundsByCarState[i].Holes > filterRoundData) {
        filterHolesData = getRoundsByCarState[i].Holes;
      }
    }
    for (let i = 0; i < getRoundsByCarState.length; i++) {
      if (getRoundsByCarState[i].Rounds > filterRoundData) {
        filterRoundData = getRoundsByCarState[i].Rounds;
        filterRoundRow = getRoundsByCarState[i];
      }
    }
  }

  const handleClick = () => {
    setOpen(false);
    setMsgToSingleCar.set(null);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleClose2 = (event, reason) => {
    if (reason && reason == "backdropClick") return;
    isLoading.set(false);
  };
  const rows =
    getCarUsageDetailState &&
    getCarUsageDetailState !== null &&
    getCarUsageDetailState !== undefined &&
    getCarUsageDetailState?.CarUsage?.length > 0 &&
    getCarUsageDetailState?.CarUsage?.map((item, index) => {
      let newRow = { id: index + 1, ...item };
      return newRow;
    });
  const includeZeroOdometerRows =
    rows !== false &&
    rows.filter(
      (item) =>
        item.Odometer === 0 ||
        item.Odometer >
        getCarUsageDetailState.AverageOdometerDetailsIncludesZero?.RangeHigh
    );
  const includeZeroWhPerMilesRows =
    rows !== false &&
    rows.filter(
      (item) =>
        item.WattHoursPerMile === 0 ||
        item.WattHoursPerMile >
        getCarUsageDetailState.AverageWattHoursPerMileDetailsIncludesZero
          ?.RangeHigh
    );

  const includeZeroKWHoursRows =
    rows !== false &&
    rows.filter(
      (item) =>
        item.KiloWattHours === 0 ||
        item.KiloWattHours >
        getCarUsageDetailState.AverageKiloWattHoursDetailsIncludesZero
          ?.RangeHigh
    );

  const includeZeroAMPHoursRows =
    rows !== false &&
    rows.filter(
      (item) =>
        item.AmpHours === 0 ||
        item.AmpHours >
        getCarUsageDetailState.AverageAmpHoursDetailsIncludesZero?.RangeHigh
    );

  const includeZeroAHPerMilesRows =
    rows !== false &&
    rows.filter(
      (item) =>
        item.AmpHoursPerMile === 0 ||
        item.AmpHoursPerMile >
        getCarUsageDetailState.AverageAmpHoursPerMileDetailsIncludesZero
          ?.RangeHigh
    );

  const GetRoundsByCarTable =
    getRoundsByCarDetailState &&
    getRoundsByCarDetailState !== null &&
    getRoundsByCarDetailState !== undefined &&
    getRoundsByCarDetailState?.CarRounds?.length > 0 &&
    getRoundsByCarDetailState?.CarRounds?.map((item, index) => {
      let getGpsiCarId =
        getCarsData &&
        getCarsData !== undefined &&
        getCarsData !== null &&
        getCarsData.length > 0 &&
        getCarsData.filter((items) => items.Car.CarNumber == item.Car);
      let newRow = {
        id: index + 1,
        GpsiCarId: getGpsiCarId[0]?.Car?.GpsiCarId,
        ...item,
      };
      return newRow;
    });

  var OdometerZeroFilterValue =
    rows &&
    rows?.filter(
      (item) =>
        item.Odometer !== 0 &&
        (item.Odometer >
          getCarUsageDetailState?.AverageOdometerDetails?.RangeHigh ||
          item.Odometer <
          getCarUsageDetailState?.AverageOdometerDetails?.RangeLow)
    );

  var WhPerMilesZeroFilterValue =
    rows &&
    rows?.filter(
      (item) =>
        item.WattHoursPerMile !== 0 &&
        (item.WattHoursPerMile >
          getCarUsageDetailState?.AverageWattHoursPerMileDetails?.RangeHigh ||
          item.WattHoursPerMile <
          getCarUsageDetailState?.AverageWattHoursPerMileDetails?.RangeLow)
    );

  var KWHoursZeroFilterValue =
    rows &&
    rows?.filter(
      (item) =>
        item.KiloWattHours !== 0 &&
        (item.KiloWattHours >
          getCarUsageDetailState?.AverageKiloWattHoursDetails?.RangeHigh ||
          item.KiloWattHours <
          getCarUsageDetailState?.AverageKiloWattHoursDetails?.RangeLow)
    );

  var AmpHoursZeroFilterValue =
    rows &&
    rows?.filter(
      (item) =>
        item.AmpHours !== 0 &&
        (item.AmpHours >
          getCarUsageDetailState?.AverageAmpHoursDetails?.RangeHigh ||
          item.AmpHours <
          getCarUsageDetailState?.AverageAmpHoursDetails?.RangeLow)
    );

  var AHPerMilesZeroFilterValue =
    rows &&
    rows?.filter(
      (item) =>
        item.AmpHoursPerMile !== 0 &&
        (item.AmpHoursPerMile >
          getCarUsageDetailState?.AverageAmpHoursPerMileDetails?.RangeHigh ||
          item.AmpHoursPerMile <
          getCarUsageDetailState?.AverageAmpHoursPerMileDetails?.RangeLow)
    );

  const includeZeroOdometer = (e) => {
    setOdometerRefreshChart(true);
    setOdometerZeroFilter(!odometerZeroFilter);
    setTimeout(() => setOdometerRefreshChart(false), 2000);
  };

  const includeZeroWattPerMiles = () => {
    setKWPerMilesRefreshChart(true);
    setWattPerMilesZeroFilter(!WattPerMilesZeroFilter);
    setTimeout(() => setKWPerMilesRefreshChart(false), 2000);
  };
  const includeZeroAmpHours = () => {
    setAMPHoursRefreshChart(true);
    setAmpHoursZeroFilter(!AmpHoursZeroFilter);
    setTimeout(() => setAMPHoursRefreshChart(false), 2000);
  };

  const includeZeroKWHours = () => {
    setKWHoursRefreshChart(true);
    setKWHoursZeroFilter(!KWHoursZeroFilter);
    setTimeout(() => setKWHoursRefreshChart(false), 2000);
  };

  const includeZeroAHPerMiles = () => {
    setAMPHoursPerMilesRefreshChart(true);
    setAHPerMilesZeroFilter(!AHPerMilesZeroFilter);
    setTimeout(() => setAMPHoursPerMilesRefreshChart(false), 2000);
  };

  const style = {
    position: "absolute",
    top: "0",
    maxWidth: "420px",
    width: "100%",
    bgcolor: "#ffffff",
    bottom: "0",
    right: "0",
    height: "100vh",
    border: "0 solid #000",
  };
  const style2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "320px",
    width: "100%",
    bgcolor: "#ffffff",
    zIndex: 1,
  };

  const style3 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "300px",
    width: "calc(100% -  40px)",
    bgcolor: "#ffffff",
    borderRadius: "5px",
    overflow: "hidden",
    paddingTop: 3,
  };

  const activeBtn = {
    background: "#BC9B6A",
    color: "#fff",
    borderColor: "#BC9B6A",
  };

  const refreshFunc = () => {
    dispatch(
      COMMON_SERVICES.getRoundsByCarServices(
        siteId.get(),
        moment(new Date(startDate)).format("YYYY-MM-DD"),
        moment(new Date(endDate)).format("YYYY-MM-DD"),
        includeMemberCars
      )
    );
    dispatch(
      COMMON_SERVICES.getRoundsByCarDetailServices(
        siteId.get(),
        moment(new Date(startDate)).format("YYYY-MM-DD"),
        moment(new Date(endDate)).format("YYYY-MM-DD"),
        includeMemberCars
      )
    );
    setDomRender(!domRender);
  };

  const openDataModal = (e) => {
    setRoundHoleRefreshChart(false);
    setAMPHoursPerMilesRefreshChart(false);
    setAMPHoursRefreshChart(false);
    setOdometerRefreshChart(false);
    setKWPerMilesRefreshChart(false);
    setKWHoursRefreshChart(false);
    // showing car number only if it is available in dataItem to avoid undefined car number in no car data modal
    if (typeof e.dataItem === "object") {
      setClickedCarNumber(e.dataItem.Car);
    } else {
      if (e.row) {
        if (e.row.Car) {
          setClickedCarNumber(e.row.Car);
        }
      }
    }

    const GpsiCarIdData = e.dataItem ? e.dataItem.GpsiCarId : e.row.GpsiCarId;
    gpsCardIdStateData.set(GpsiCarIdData);
    const payload = {
      GpsiCarId: GpsiCarIdData,
    };
    dispatch(COMMON_SERVICES.getProductData(payload));
    const carObj =
      getCarsData &&
      getCarsData !== undefined &&
      getCarsData !== null &&
      getCarsData.filter((item) => item?.Car?.GpsiCarId === GpsiCarIdData);
    setTempCarObj(carObj[0]);
    if (carObj.length > 0) {
      setOpen(true);
    } else {
      // handling modal status to true only in case of car number is availabale
      if (typeof e.dataItem === "object") {
        setOpenCarNotFound(true);
      } else {
        if (e.row) {
          if (e.row.Car) {
            setOpenCarNotFound(true);
          }
        }
      }
    }

    if (updatedCarData.get() && updatedCarData.get().length !== 0) {
      let carData = JSON.parse(updatedCarData.get());
      if (carData && Array.isArray(carData) && carData.length !== 0) {
        const carObjData = carData.filter(
          (item) => item?.Car?.GpsiCarId === GpsiCarIdData
        );
        setTempCarObj(carObjData[0]);
      }
    } else {
      setTempCarObj(null);
    }
  };

  const createCarAmpHoursChart = (
    carAmpHoursDivId,
    carAmpHoursText,
    AmpUsageData
  ) => {
    var carListAmpHours = [];

    var ampHoursArray = [];
    AmpUsageData.forEach((ampHours, index) => {
      ampHoursArray.push(ampHours.AmpHours);
    });
    var rangeAvgAmpHour;
    var rangeHighAmpHour;
    var rangeLowAmpHour;

    var sigmaOnAmpHours = Math.round(getSigmaOnArray(ampHoursArray));
    if (ampHoursArray.length > 0) {
      rangeAvgAmpHour = Math.round(getAvgFromArray(ampHoursArray));
      rangeHighAmpHour = rangeAvgAmpHour + sigmaOnAmpHours;
      if (Math.round(getAvgFromArray(ampHoursArray)) - sigmaOnAmpHours < 0) {
        rangeLowAmpHour = 0;
      } else {
        rangeLowAmpHour = rangeAvgAmpHour - sigmaOnAmpHours;
      }
    } else {
      rangeAvgAmpHour = "NA";
      rangeHighAmpHour = "NA";
      rangeLowAmpHour = "NA";
    }
    setRangeHighAmpHours(rangeHighAmpHour);
    setRangeLowAmpHours(rangeLowAmpHour);
    var ampHourAvgArray = [];
    for (var i = 0, length = AmpUsageData.length; i < length; i++) {
      ampHourAvgArray.push(rangeAvgAmpHour);
      if (
        AmpUsageData[i].AmpHours > rangeHighAmpHour ||
        AmpUsageData[i].AmpHours < rangeLowAmpHour ||
        (rangeLowAmpHour === 0 && AmpUsageData[i].AmpHours === 0)
      ) {
        carListAmpHours.push({
          Car: AmpUsageData[i].CarNumber,
          AmpHours: AmpUsageData[i].AmpHours,
        });
      }
    }

    setAmpHourAvgArrays(ampHourAvgArray);

    var ampHoursMinMax = getMinMaxForChart(
      ampHoursArray,
      rangeAvgAmpHour,
      sigmaOnAmpHours
    );
    setMaxAmpGraph(ampHoursMinMax.Max);
    setMinAmpGraph(ampHoursMinMax.Min > 0 ? ampHoursMinMax.Min : 0);
  };

  useEffect(() => {
    let ampHourData = [];
    if (getCarUsageDetailState && Object.keys(getCarUsageDetailState)?.length) {
      getCarUsageDetailState?.CarUsage?.forEach((carData) => {
        if (!AmpHoursZeroFilter || carData.AmpHours) {
          let datum = {
            AmpHours: carData.AmpHours,
            Odometer: carData.Odometer,
            GpsiCarId: carData.GpsiCarId,
            CarNumber: carData.CarNumber,
          };
          ampHourData.push(datum);
        }
      });
      createCarAmpHoursChart("", "", ampHourData);
    }
  }, [getCarUsageDetailState, AmpHoursZeroFilter]);

  function getAvgFromArray(arrayToAverage) {
    var arrayItemTotal = 0;
    var arrayLength = arrayToAverage !== undefined && arrayToAverage.length;
    for (var i = 0; i < arrayLength; i++) {
      arrayItemTotal = arrayItemTotal + arrayToAverage[i];
    }
    return arrayItemTotal / arrayLength;
  }
  var tempArray = []; //to get average

  function getSigmaOnArray(arrayToSigma) {
    var arrayLength = arrayToSigma !== undefined && arrayToSigma.length;
    var interimArray = [];
    var initialArrayAverage = getAvgFromArray(arrayToSigma);
    for (var i = 0; i < arrayLength; i++) {
      interimArray.push(
        (arrayToSigma[i] - initialArrayAverage) *
        (arrayToSigma[i] - initialArrayAverage)
      );
    }
    var interimArrayAvergage = getAvgFromArray(interimArray);
    var arraySigma = Math.sqrt(interimArrayAvergage);
    return arraySigma;
  }

  var sigmaRounds = Math.round(getSigmaOnArray(tempArray));

  let tempArrayAVG = []; //to get average
  if (
    getRoundsByCarDetailState &&
    Object.keys(getRoundsByCarDetailState).length > 0
  ) {
    for (
      var i = 0, rlength = getRoundsByCarDetailState.CarRounds.length;
      i < rlength;
      i++
    ) {
      if (roundStateGlobal.get()) {
        tempArrayAVG.push(getRoundsByCarDetailState.CarRounds[i].Rounds);
      } else {
        tempArrayAVG.push(getRoundsByCarDetailState.CarRounds[i].Holes);
      }
    }
  }

  var sigmaRounds = !isNaN(Math.round(getSigmaOnArray(tempArrayAVG)))
    ? Math.round(getSigmaOnArray(tempArrayAVG))
    : 0;
  var averageRounds = !isNaN(Math.round(getAvgFromArray(tempArrayAVG)))
    ? Math.round(getAvgFromArray(tempArrayAVG))
    : 0;
  var roundsMinMax = getMinMaxForChart(
    tempArrayAVG,
    !isNaN(averageRounds) ? averageRounds : 0,
    !isNaN(sigmaRounds) ? sigmaRounds : 0
  );
  var roundsMax = roundsMinMax.Max;
  var roundsMin = roundsMinMax.Min <= 1 ? 0 : roundsMinMax.Min; //if min is 1, start chart at 0 to show cars with min (or anything less since no negative rounds)

  var rangeLowRounds = null;
  const rangeHighRounds = averageRounds + sigmaRounds;

  if (averageRounds - sigmaRounds < 0) {
    rangeLowRounds = 0;
  } else {
    rangeLowRounds = averageRounds - sigmaRounds;
  }

  const getTooltipColor = (points) => {
    if (
      getRoundsByCarDetailState &&
      Object.keys(getRoundsByCarDetailState).length > 0
    ) {
      if (
        points > rangeHighRounds ||
        points < rangeLowRounds ||
        (getRoundsByCarDetailState?.AverageRoundDetails?.RangeLow === 0 &&
          points === 0)
      ) {
        return "red";
      } else {
        return "green";
      }
    }
  };

  const avarageRoundDataValue =
    GetRoundsByCarTable !== false &&
    GetRoundsByCarTable.filter(
      (item) =>
        item?.Holes >
        getRoundsByCarDetailState?.AverageHoleDetails?.RangeHigh ||
        item?.Holes < getRoundsByCarDetailState?.AverageHoleDetails?.RangeLow ||
        item?.Rounds >
        getRoundsByCarDetailState?.AverageRoundDetails?.RangeHigh ||
        item?.Rounds < rangeLowRounds
    );

  const uniqueObjects = {};

  // Filter and update uniqueObjects with objects where Rounds > 9 and < 2
  const filteredRangeData =
    avarageRoundDataValue?.length &&
    avarageRoundDataValue.filter((obj) => {
      const roundsValue = obj.Rounds;

      // If the Rounds value is greater than 9 and less than 2, include it
      if (roundsValue > rangeHighRounds || roundsValue < rangeLowRounds) {
        // Check for duplicates
        if (
          !(roundsValue in uniqueObjects) ||
          obj.Rounds > uniqueObjects[roundsValue].Rounds
        ) {
          uniqueObjects[roundsValue] = obj;
        }
        return true;
      }

      return false;
    });

  function getMinMaxForChart(chartArray, avgFromArray, sigmaFromArray) {
    var tempChartMinMax = {};
    var tempChartMin;
    var tempChartMax;

    //get min and max from odometer array
    var arrayMin = roundDownNearestPow10(getMinFromArray(chartArray));

    //get min and max based on 2 sigmas from avg
    var maxFromAvg = avgFromArray + 2 * sigmaFromArray;
    var minFromAvg = roundDownNearestPow10(avgFromArray - 2 * sigmaFromArray);

    //compare the two, use min from array if lower since it will include all cars, if same calculate min based on range
    if (arrayMin < minFromAvg) {
      tempChartMin = arrayMin < 0 ? 0 : arrayMin;
    } else if (arrayMin === minFromAvg) {
      if (maxFromAvg - minFromAvg < 10) {
        //really small range
        tempChartMin = arrayMin <= 0 ? 0 : arrayMin - 0.2;
      } else {
        var numDigs = getNumberOfDigits(maxFromAvg - minFromAvg) - 1;
        tempChartMin = arrayMin <= 0 ? 0 : arrayMin - Math.pow(10, numDigs);
      }
    } else {
      tempChartMin = minFromAvg < 0 ? 0 : minFromAvg;
    }

    //set max based on min to keep avg line in the middle
    var diffBetweenAvgAndMin = avgFromArray - tempChartMin;
    tempChartMax = avgFromArray + diffBetweenAvgAndMin;

    tempChartMinMax.Min = tempChartMin;
    tempChartMinMax.Max = tempChartMax;

    return tempChartMinMax;
  }

  function getMinFromArray(arrayForMin) {
    var tempmin = arrayForMin[0];
    for (i = 0; i < arrayForMin.length; i++) {
      if (arrayForMin[i] < tempmin) {
        tempmin = arrayForMin[i];
      }
    }
    return tempmin;
  }

  function roundDownNearestPow10(valueToRound) {
    if (valueToRound < 10) {
      return Math.floor(valueToRound);
    } else {
      //get number of digits to use as the power of ten to round to
      var numDigits = getNumberOfDigits(valueToRound);
      //use one less digit to round down to
      var roundDigit = numDigits - 1;
      //get roundTo number using power of 10 to number of digits
      var roundTo = Math.pow(10, roundDigit);
      return Math.floor(valueToRound / roundTo) * roundTo;
    }
  }

  function getNumberOfDigits(numToCheck) {
    var tempN = numToCheck;
    tempN = Math.log(tempN) / Math.log(10);
    tempN = Math.ceil(tempN);
    return tempN;
  }

  const SharedRoundTooltip = (props) => {
    const { category, points } = props;
    return (
      <div
        style={{
          backgroundColor: getTooltipColor(points[0].value),
          padding: "0px 5px 0px 5px",
        }}
      >
        {roundStateGlobal.get() ? (
          <>
            {t("Car")} {points[0]?.dataItem?.Car} {t("Rounds")}{" "}
            {points[0]?.dataItem?.Rounds}
          </>
        ) : (
          <>
            {t("Car")} {points[0]?.dataItem?.Car} {t("Holes")}{" "}
            {points[0]?.dataItem?.Holes}
          </>
        )}
      </div>
    );
  };
  const SharedTooltip = (props) => {
    const { category, points } = props;
    return (
      <div>
        Car {points[0]?.dataItem?.CarNumber} {t("Amp_Hours")}{" "}
        {points[0]?.dataItem?.AmpHours}
      </div>
    );
  };
  const SharedWHMilesTooltip = (props) => {
    const { category, points } = props;
    return (
      <div>
        Car {points[0]?.dataItem?.CarNumber} {t("WH_per_Mile")}{" "}
        {points[0]?.dataItem?.WattHoursPerMile}
      </div>
    );
  };

  const SharedKWHoursTooltip = (props) => {
    const { category, points } = props;
    return (
      <div>
        Car {points[0]?.dataItem?.CarNumber} {t("kW_Hours")}{" "}
        {points[0]?.dataItem?.KiloWattHours}
      </div>
    );
  };
  const SharedOdometerTooltip = (props) => {
    const { category, points } = props;
    return (
      <div>
        Car {points[0]?.dataItem?.CarNumber} {t("odometer")}{" "}
        {points[0]?.dataItem?.Odometer}
      </div>
    );
  };
  const SharedAHPermileTooltip = (props) => {
    const { category, points } = props;
    return (
      <div>
        Car {points[0]?.dataItem?.CarNumber} {t("AH_per_Mile")}{" "}
        {points[0]?.dataItem?.AmpHoursPerMile}
      </div>
    );
  };

  const sharedTooltipRender = (context) => <SharedTooltip {...context} />;
  const sharedRoundTooltipRender = (roundContext) => (
    <SharedRoundTooltip {...roundContext} />
  );
  const sharedOdometerTooltipRender = (contexts) => (
    <SharedOdometerTooltip {...contexts} />
  );
  const sharedKWHoursTooltipRender = (contexts) => (
    <SharedKWHoursTooltip {...contexts} />
  );
  const sharedWhMilesTooltipRender = (contexts) => (
    <SharedWHMilesTooltip {...contexts} />
  );
  const sharedAHPerMileTooltipRender = (AHPerMilecontext) => (
    <SharedAHPermileTooltip {...AHPerMilecontext} />
  );

  function paceString() {
    let result = "";
    if (TempCarObj) {
      if (TempCarObj?.Car?.Pace > 0)
        result = TempCarObj?.Car?.Pace.toString() + " min ahead ";
      else if (TempCarObj?.Car?.Pace < 0)
        result = (-TempCarObj?.Car?.Pace).toString() + " min behind ";
      else result = "on pace ";
      if (TempCarObj?.Car?.HolesPlayed > 0)
        result =
          result +
          "through " +
          TempCarObj?.Car?.HolesPlayed.toString() +
          " hole" +
          (TempCarObj?.Car?.HolesPlayed > 1 ? "s" : "");
    }
    return result;
  }
  const RounddownloadFile = async () => {
    try {
      let response = await API_CALLS.getExportRoundByCarApiCall(
        siteId.get(),
        includeMemberCars,
        startDate,
        endDate,
        headersConfigData
      );
      let jsonResponse = await response.text();
      let hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURIComponent(jsonResponse);
      hiddenElement.target = "_blank";
      hiddenElement.download = "Car Rounds.csv";
      hiddenElement.click();
    } catch (error) { }
  };

  const downloadFile = async () => {
    let SiteName =
      siteSettingsData &&
      siteSettingsData !== undefined &&
      siteSettingsData?.Name;
    var fileName = `Car Usage - ${SiteName} - ${moment(new Date()).format(
      "DDMMMYYYY"
    )}.csv`;

    try {
      let response = await API_CALLS.getExportUsageApiCall(
        siteId.get(),
        includeMemberCars,
        useKMInstead,
        headersConfigData
      );
      let jsonResponse = await response.text();
      let hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURIComponent(jsonResponse);
      hiddenElement.target = "_blank";
      hiddenElement.download = fileName;
      hiddenElement.click();
    } catch (error) { }
  };

  if (siteSettingDataReduxStateStatus === API_STATUSES.REQUEST) {
    return <Loader />;
  }
  const showYearlyData = () => {
    setMtdState(false);
    setQtdState(false);
    setYTDState(true);
    setStartDate(moment().set({ date: 1, month: 0 }).format("YYYY-MM-DD"));
    setEndDate(moment(new Date()).format("YYYY-MM-DD"));
  };
  const showQuaterlyData = () => {
    setMtdState(false);
    setQtdState(true);
    setYTDState(false);
    let getQuater = Math.floor(moment().month() / 3);
    setStartDate(
      moment()
        .set({ date: 1, month: getQuater * 3 })
        .format("YYYY-MM-DD")
    );
    setEndDate(moment(new Date()).format("YYYY-MM-DD"));
  };


  const handleKWHoursChartRefresh = (
    chartOptions,
    themeOptions,
    chartInstance
  ) => {
    if (KWHoursRefreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  const handleWPPerMilesChartRefresh = (
    chartOptions,
    themeOptions,
    chartInstance
  ) => {
    if (KWPerMilesRefreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  const handleOdometerChartRefresh = (
    chartOptions,
    themeOptions,
    chartInstance
  ) => {
    if (OdometerRefreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  const handleAMPHoursChartRefresh = (
    chartOptions,
    themeOptions,
    chartInstance
  ) => {
    if (AMPHoursRefreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  const handleAMPHoursPerMilesChartRefresh = (
    chartOptions,
    themeOptions,
    chartInstance
  ) => {
    if (AMPHoursPerMilesRefreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  const handleRoundHoleChartRefresh = (
    chartOptions,
    themeOptions,
    chartInstance
  ) => {
    if (RoundHoleRefreshChart) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  return (
    <Wrapper>

      <UsageContainer>
        {isMemberCar &&
        <Tooltip title={t("Include_Member_Cars")} className="title">
          <FormControlLabel
            label={t("Include_Member_Cars")}
            control={
              <Checkbox
                checked={includeMemberCars}
                onClick={() => setIncludeMemberCars(!includeMemberCars)}
                icon={<UnCheckIcon width={20} height={20} />}
                checkedIcon={
                  <CheckIcon width={20} height={20} />
                }
              />
            }
          />
        </Tooltip>}
        <ChartRow>
          <div>
            {getCarUsageDetailState &&
              getCarUsageDetailState !== null &&
              getCarUsageDetailState !== undefined &&
              getCarUsageDetailState?.AverageKiloWattHoursDetails !== null ? (
              <Chart
                onRefresh={handleKWHoursChartRefresh}
                onSeriesClick={(e) => openDataModal(e)}
              >
                <ChartArea background="#fff" margin={0} />
                <ChartLegend visible={false} />
                <ChartTitle text={t("kW_Hours")} font="14pt sans-serif" />
                <ChartTooltip
                  border={{ color: "white" }}
                  background="green"
                  color="white"
                  shared={true}
                  render={sharedKWHoursTooltipRender}
                  visible={true}
                />
                <ChartSeriesDefaults type="column" line={{ width: 1 }} />
                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    axisCrossingValue={0}
                    minorTicks={{ visible: false }}
                    labels={{ visible: false }}
                    field="CarNumber"
                  />
                </ChartCategoryAxis>
                <ChartValueAxis>
                  <ChartValueAxisItem
                    axisCrossingValue={0}
                    labels={{
                      color: "black",
                      format: "{0}",
                    }}
                    plotBands={[
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageKiloWattHoursDetails
                            ?.RangeHigh,
                        to: 1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageKiloWattHoursDetails
                            ?.RangeLow,
                        to: -1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageKiloWattHoursDetails
                            ?.Average,
                        to:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageKiloWattHoursDetails
                            ?.RangeHigh,
                        color: "green",
                        opacity: 0.2,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageKiloWattHoursDetails
                            ?.Average,
                        to:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageKiloWattHoursDetails
                            ?.RangeLow,
                        color: "green",
                        opacity: 0.2,
                      },
                    ]}
                    min={
                      KWHoursZeroFilter
                        ? KWHoursChartZeroFilterData !== undefined &&
                        Math.min(
                          ...KWHoursChartZeroFilterData.map(
                            (o) => o.KiloWattHours
                          )
                        )
                        : ampHoursData !== undefined &&
                        Math.min(...ampHoursData.map((o) => o.KiloWattHours))
                    }
                    max={
                      KWHoursZeroFilter
                        ? KWHoursChartZeroFilterData !== undefined &&
                        Math.max(
                          ...KWHoursChartZeroFilterData.map(
                            (o) => o.KiloWattHours
                          )
                        )
                        : ampHoursData !== undefined &&
                        Math.max(...ampHoursData.map((o) => o.KiloWattHours))
                    }
                    minorTicks={{ visible: false }}
                  />
                </ChartValueAxis>
                <ChartSeries>
                  <ChartSeriesItem
                    gap={0}
                    line={1}
                    type="column"
                    stack={false}
                    field="KiloWattHours"
                    name="KiloWattHours"
                    color={(e) =>
                      e.value >
                        getCarUsageDetailTempState?.AverageKiloWattHoursDetails
                          ?.RangeHigh ||
                        e.value <
                        getCarUsageDetailTempState?.AverageKiloWattHoursDetails
                          ?.RangeLow ||
                        (getCarUsageDetailTempState?.AverageKiloWattHoursDetails
                          ?.RangeLow === 0 &&
                          e.value === 0)
                        ? "red"
                        : "green"
                    }
                    data={
                      KWHoursZeroFilter
                        ? KWHoursChartZeroFilterData !== undefined &&
                        KWHoursChartZeroFilterData.sort(
                          (a, b) => a.KiloWattHours - b.KiloWattHours
                        )
                        : ampHoursData !== undefined &&
                        ampHoursData.sort(
                          (a, b) => a.KiloWattHours - b.KiloWattHours
                        )
                    }
                  />

                  <ChartSeriesItem
                    type="line"
                    style="smooth"
                    name="Average"
                    color="black"
                    markers={{
                      visible: false,
                    }}
                    data={kwHoursAverageData}
                  />
                </ChartSeries>
              </Chart>
            ) : (
              <>
                <strong>{t("kW_Hours")}</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
          <div>
            <div className="heading">
              <div>
                {t("Average")}:{" "}
                {KWHoursZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageKiloWattHoursDetails?.Average
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState
                    ?.AverageKiloWattHoursDetailsIncludesZero?.Average}{" "}
              </div>
              <div>
                {t("Range")}:{" "}
                {KWHoursZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageKiloWattHoursDetails
                    ?.RangeLow
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState
                    ?.AverageKiloWattHoursDetailsIncludesZero?.RangeLow}{" "}
                -{" "}
                {KWHoursZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageKiloWattHoursDetails
                    ?.RangeHigh
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState
                    ?.AverageKiloWattHoursDetailsIncludesZero?.RangeHigh}{" "}
              </div>
              <div>{t("Cars_outside_range")}</div>
            </div>
            <DataGrid
              rows={
                KWHoursZeroFilter
                  ? KWHoursZeroFilterValue !== null && KWHoursZeroFilterValue
                  : rows !== null && includeZeroKWHoursRows
              }
              columns={[
                {
                  field: "CarNumber",
                  headerName: "Car",
                  width: 180,
                  sortable: true,
                },
                {
                  field: "KiloWattHours",
                  headerName: t("kW_Hours"),
                  width: 180,
                  sortable: true,
                },
              ]}
              onRowClick={(e) => openDataModal(e)}
              pageSize={
                (KWHoursZeroFilter
                  ? KWHoursZeroFilterValue !== null &&
                  KWHoursZeroFilterValue.length
                  : rows !== null && includeZeroKWHoursRows.length) > 100 ? 100 : (KWHoursZeroFilter
                    ? KWHoursZeroFilterValue !== null &&
                    KWHoursZeroFilterValue.length
                    : rows !== null && includeZeroKWHoursRows.length)
              }
            />
            <div className="action-btn">
              <div>
                <input
                  type="checkbox"
                  onChange={(e) => includeZeroKWHours(e)}
                />{" "}
                Include zeros
              </div>
              <button onClick={downloadFile}>{t("Download")}</button>
            </div>
          </div>
        </ChartRow>
        {/* Chart of WH per Mile */}
        <ChartRow>
          <div>
            {getCarUsageDetailState &&
              getCarUsageDetailState !== null &&
              getCarUsageDetailState !== undefined &&
              getCarUsageDetailState?.AverageKiloWattHoursDetails !== null ? (
              <Chart
                onRefresh={handleWPPerMilesChartRefresh}
                onSeriesClick={(e) => openDataModal(e)}
              >
                <ChartArea background="#fff" margin={0} />
                <ChartLegend visible={false} />
                <ChartTitle text={t("WH_per_Mile")} font="14pt sans-serif" />
                <ChartTooltip
                  border={{ color: "white" }}
                  background="green"
                  color="white"
                  shared={true}
                  render={sharedWhMilesTooltipRender}
                  visible={true}
                />
                <ChartSeriesDefaults type="column" line={{ width: 1 }} />
                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    axisCrossingValue={0}
                    minorTicks={{ visible: false }}
                    labels={{ visible: false }}
                    field="CarNumber"
                  />
                </ChartCategoryAxis>
                <ChartValueAxis>
                  <ChartValueAxisItem
                    axisCrossingValue={0}
                    labels={{
                      color: "black",
                      format: "{0}",
                    }}
                    plotBands={[
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageWattHoursPerMileDetails
                            ?.RangeHigh,
                        to: 1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageWattHoursPerMileDetails
                            ?.RangeLow,
                        to: -1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageWattHoursPerMileDetails
                            ?.Average,
                        to:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageWattHoursPerMileDetails
                            ?.RangeHigh,
                        color: "green",
                        opacity: 0.2,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageWattHoursPerMileDetails
                            ?.Average,
                        to:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageWattHoursPerMileDetails
                            ?.RangeLow,
                        color: "green",
                        opacity: 0.2,
                      },
                    ]}
                    min={
                      WattPerMilesZeroFilter
                        ? WattHoursPerMileChartZeroFilterData !== undefined &&
                        Math.min(
                          ...WattHoursPerMileChartZeroFilterData.map(
                            (o) => o.WattHoursPerMile
                          )
                        )
                        : ampHoursData !== undefined &&
                        Math.min(
                          ...ampHoursData.map((o) => o.WattHoursPerMile)
                        )
                    }
                    max={
                      WattPerMilesZeroFilter
                        ? WattHoursPerMileChartZeroFilterData !== undefined &&
                        Math.max(
                          ...WattHoursPerMileChartZeroFilterData.map(
                            (o) => o.WattHoursPerMile
                          )
                        )
                        : ampHoursData !== undefined &&
                        Math.max(
                          ...ampHoursData.map((o) => o.WattHoursPerMile)
                        )
                    }
                    minorTicks={{ visible: false }}
                  />
                </ChartValueAxis>
                <ChartSeries>
                  <ChartSeriesItem
                    gap={0}
                    line={1}
                    type="column"
                    stack={false}
                    field="WattHoursPerMile"
                    name="WattHoursPerMile"
                    color={(e) =>
                      e.value >
                        getCarUsageDetailTempState
                          ?.AverageWattHoursPerMileDetails?.RangeHigh ||
                        e.value <
                        getCarUsageDetailTempState
                          ?.AverageWattHoursPerMileDetails?.RangeLow ||
                        (getCarUsageDetailTempState
                          ?.AverageWattHoursPerMileDetails?.RangeLow === 0 &&
                          e.value === 0)
                        ? "red"
                        : "green"
                    }
                    data={
                      WattPerMilesZeroFilter
                        ? WattHoursPerMileChartZeroFilterData !== undefined &&
                        WattHoursPerMileChartZeroFilterData.sort(
                          (a, b) => a.WattHoursPerMile - b.WattHoursPerMile
                        )
                        : ampHoursData !== undefined &&
                        ampHoursData.sort(
                          (a, b) => a.WattHoursPerMile - b.WattHoursPerMile
                        )
                    }
                  />

                  <ChartSeriesItem
                    type="line"
                    style="smooth"
                    name="Average"
                    color="black"
                    markers={{
                      visible: false,
                    }}
                    data={WattHourPerMilesAverageData}
                  />
                </ChartSeries>
              </Chart>
            ) : (
              <>
                <strong>{t("WH_per_Mile")}</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
          <div>
            <div className="heading">
              <div>
                {t("Average")}:{" "}
                {WattPerMilesZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageWattHoursPerMileDetails
                    ?.Average
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState
                    ?.AverageWattHoursPerMileDetailsIncludesZero
                    ?.Average}{" "}
              </div>
              <div>
                {t("Range")}:{" "}
                {WattPerMilesZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageWattHoursPerMileDetails
                    ?.RangeLow
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState
                    ?.AverageWattHoursPerMileDetailsIncludesZero
                    ?.RangeLow}{" "}
                -{" "}
                {WattPerMilesZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageWattHoursPerMileDetails
                    ?.RangeHigh
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState
                    ?.AverageWattHoursPerMileDetailsIncludesZero
                    ?.RangeHigh}{" "}
              </div>
              <div>{t("Cars_outside_range")}</div>
            </div>
            <DataGrid
              rows={
                WattPerMilesZeroFilter
                  ? WhPerMilesZeroFilterValue !== null &&
                  WhPerMilesZeroFilterValue
                  : rows !== null && includeZeroWhPerMilesRows
              }
              columns={[
                {
                  field: "CarNumber",
                  headerName: "Car",
                  width: 180,
                  sortable: true,
                },
                {
                  field: "WattHoursPerMile",
                  headerName: t("WH/Mile"),
                  width: 180,
                  sortable: true,
                },
              ]}
              onRowClick={(e) => openDataModal(e)}
              pageSize={
                (WattPerMilesZeroFilter
                  ? WhPerMilesZeroFilterValue !== null &&
                  WhPerMilesZeroFilterValue.length
                  : rows !== null && includeZeroWhPerMilesRows.length) > 100 ? 100 : (WattPerMilesZeroFilter
                    ? WhPerMilesZeroFilterValue !== null &&
                    WhPerMilesZeroFilterValue.length
                    : rows !== null && includeZeroWhPerMilesRows.length)
              }
            />
            <div className="action-btn">
              <div>
                <input
                  type="checkbox"
                  onChange={(e) => includeZeroWattPerMiles(e)}
                />{" "}
                Include zeros
              </div>
              <button onClick={downloadFile}>{t("Download")}</button>
            </div>
          </div>
        </ChartRow>

        {/* Chart of odometer */}
        <ChartRow>
          <div>
            {getCarUsageDetailState &&
              getCarUsageDetailState !== null &&
              getCarUsageDetailState !== undefined &&
              getCarUsageDetailState?.AverageOdometerDetails !== null ? (
              <Chart
                onRefresh={handleOdometerChartRefresh}
                onSeriesClick={(e) => openDataModal(e)}
              >
                <ChartArea background="#fff" margin={0} />
                <ChartLegend visible={false} />
                <ChartTitle text={t("odometer")} font="14pt sans-serif" />
                <ChartTooltip
                  border={{ color: "white" }}
                  background="green"
                  color="white"
                  shared={true}
                  render={sharedOdometerTooltipRender}
                  visible={true}
                />
                <ChartSeriesDefaults type="column" line={{ width: 1 }} />
                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    axisCrossingValue={0}
                    minorTicks={{ visible: false }}
                    labels={{ visible: false }}
                    field="CarNumber"
                  />
                </ChartCategoryAxis>
                <ChartValueAxis>
                  <ChartValueAxisItem
                    axisCrossingValue={0}
                    labels={{
                      color: "black",
                      format: "{0}",
                    }}
                    plotBands={[
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageOdometerDetails
                            ?.RangeHigh,
                        to: 1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageOdometerDetails
                            ?.RangeLow,
                        to: -1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageOdometerDetails
                            ?.Average,
                        to:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageOdometerDetails
                            ?.RangeHigh,
                        color: "green",
                        opacity: 0.2,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageOdometerDetails
                            ?.Average,
                        to:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageOdometerDetails
                            ?.RangeLow,
                        color: "green",
                        opacity: 0.2,
                      },
                    ]}
                    min={
                      odometerZeroFilter
                        ? OdometerChartZeroFilterData !== undefined &&
                        Math.min(
                          ...OdometerChartZeroFilterData.map(
                            (o) => o.Odometer
                          )
                        )
                        : ampHoursData !== undefined &&
                        Math.min(...ampHoursData.map((o) => o.Odometer))
                    }
                    max={
                      odometerZeroFilter
                        ? OdometerChartZeroFilterData !== undefined &&
                        Math.max(
                          ...OdometerChartZeroFilterData.map(
                            (o) => o.Odometer
                          )
                        )
                        : ampHoursData !== undefined &&
                        Math.max(...ampHoursData.map((o) => o.Odometer))
                    }
                    minorTicks={{ visible: false }}
                  />
                </ChartValueAxis>
                <ChartSeries>
                  <ChartSeriesItem
                    gap={0}
                    line={1}
                    field="Odometer"
                    name="Odometer"
                    color={(e) =>
                      e.value >
                        getCarUsageDetailTempState?.AverageOdometerDetails
                          ?.RangeHigh ||
                        e.value <
                        getCarUsageDetailTempState?.AverageOdometerDetails
                          ?.RangeLow ||
                        (getCarUsageDetailTempState?.AverageOdometerDetails
                          ?.RangeLow === 0 &&
                          e.value === 0)
                        ? "red"
                        : "green"
                    }
                    data={
                      odometerZeroFilter
                        ? OdometerChartZeroFilterData !== undefined &&
                        OdometerChartZeroFilterData.sort(
                          (a, b) => a.Odometer - b.Odometer
                        )
                        : ampHoursData !== undefined &&
                        ampHoursData.sort((a, b) => a.Odometer - b.Odometer)
                    }
                  />

                  <ChartSeriesItem
                    type="line"
                    style="smooth"
                    name="Average"
                    color="black"
                    markers={{
                      visible: false,
                    }}
                    data={odometerAverageData}
                  />
                </ChartSeries>
              </Chart>
            ) : (
              <>
                <strong>{t("odometer")}</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
          <div>
            <div className="heading">
              <div>
                {t("Average")}:{" "}
                {odometerZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageOdometerDetails?.Average
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageOdometerDetailsIncludesZero
                    ?.Average}{" "}
              </div>
              <div>
                {t("Range")}:{" "}
                {odometerZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageOdometerDetails?.RangeLow
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageOdometerDetailsIncludesZero
                    ?.RangeLow}{" "}
                -{" "}
                {odometerZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageOdometerDetails?.RangeHigh
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageOdometerDetailsIncludesZero
                    ?.RangeHigh}{" "}
              </div>
              <div>{t("Cars_outside_range")}</div>
            </div>
            <DataGrid
              rows={
                odometerZeroFilter
                  ? OdometerZeroFilterValue !== null && OdometerZeroFilterValue
                  : rows !== null && includeZeroOdometerRows
              }
              onRowClick={(e) => openDataModal(e)}
              columns={[
                {
                  field: "CarNumber",
                  headerName: t("car"),
                  width: 180,
                  sortable: true,
                },
                {
                  field: "Odometer",
                  headerName: t("odometer"),
                  width: 180,
                  sortable: true,
                },
              ]}
              pageSize={
                (odometerZeroFilter
                  ? OdometerZeroFilterValue !== null &&
                  OdometerZeroFilterValue.length
                  : rows !== null && includeZeroOdometerRows.length) > 100 ? 100 : (odometerZeroFilter
                    ? OdometerZeroFilterValue !== null &&
                    OdometerZeroFilterValue.length
                    : rows !== null && includeZeroOdometerRows.length)
              }
            />
            <div className="action-btn">
              <div>
                <input
                  type="checkbox"
                  onChange={(e) => includeZeroOdometer(e)}
                />{" "}
                Include zeros
              </div>
              <button onClick={downloadFile}>{t("Download")}</button>
            </div>
          </div>
        </ChartRow>

        {/* Chart of amp hours*/}
        <ChartRow>
          <div>
            {getCarUsageDetailState &&
              getCarUsageDetailState !== null &&
              getCarUsageDetailState !== undefined &&
              getCarUsageDetailState?.AverageAmpHoursDetails !== null ? (
              <Chart
                onRefresh={handleAMPHoursChartRefresh}
                onSeriesClick={(e) => openDataModal(e)}
              >
                <ChartArea background="#fff" margin={0} />
                <ChartLegend visible={false} />
                <ChartTitle text={t("Amp_Hours")} font="14pt sans-serif" />
                <ChartTooltip
                  border={{ color: "white" }}
                  background="green"
                  color="white"
                  shared={true}
                  render={sharedTooltipRender}
                  visible={true}
                />
                <ChartSeriesDefaults type="column" line={{ width: 1 }} />
                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    axisCrossingValue={0}
                    minorTicks={{ visible: false }}
                    labels={{ visible: false }}
                    field="CarNumber"
                  />
                </ChartCategoryAxis>
                <ChartValueAxis>
                  <ChartValueAxisItem
                    axisCrossingValue={0}
                    labels={{
                      color: "black",
                      format: "{0}",
                    }}
                    plotBands={[
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursDetails
                            ?.RangeHigh,
                        to: 1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursDetails
                            ?.RangeLow,
                        to: -1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursDetails
                            ?.Average,
                        to:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursDetails
                            ?.RangeHigh,
                        color: "green",
                        opacity: 0.2,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursDetails
                            ?.Average,
                        to:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursDetails
                            ?.RangeLow,
                        color: "green",
                        opacity: 0.2,
                      },
                    ]}
                    min={minAmpGraph}
                    max={maxAmpGraph}
                    minorTicks={{ visible: false }}
                  />
                </ChartValueAxis>
                <ChartSeries>
                  <ChartSeriesItem
                    gap={0}
                    line={1}
                    field="AmpHours"
                    name="AmpHours"
                    color={(e) => {
                      if (
                        getCarUsageDetailState &&
                        Object.keys(getCarUsageDetailState).length > 0
                      ) {
                        if (
                          e.value > rangeHighAmpHours ||
                          e.value < rangeLowAmpHours ||
                          (rangeLowAmpHours === 0 && e.value === 0)
                        ) {
                          return "red";
                        } else {
                          return "green";
                        }
                      }
                    }}
                    data={
                      AmpHoursZeroFilter
                        ? ampHoursZeroFilterData !== undefined &&
                        ampHoursZeroFilterData.sort(
                          (a, b) => a.AmpHours - b.AmpHours
                        )
                        : ampHoursData !== undefined &&
                        ampHoursData.sort((a, b) => a.AmpHours - b.AmpHours)
                    }
                  />
                  <ChartSeriesItem
                    type="line"
                    style="smooth"
                    name="Average"
                    color="black"
                    markers={{
                      visible: false,
                    }}
                    data={ampHourAvgArrays}
                  />
                </ChartSeries>
              </Chart>
            ) : (
              <>
                <strong>{t("Amp_Hours")}</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
          <div>
            <div className="heading">
              <div>
                {t("Average")}:{" "}
                {AmpHoursZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursDetails?.Average
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursDetailsIncludesZero
                    ?.Average}{" "}
              </div>
              <div>
                {t("Range")}:{" "}
                {AmpHoursZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursDetails?.RangeLow
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursDetailsIncludesZero
                    ?.RangeLow}{" "}
                -{" "}
                {AmpHoursZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursDetails?.RangeHigh
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursDetailsIncludesZero
                    ?.RangeHigh}{" "}
              </div>
              <div>{t("Cars_outside_range")}</div>
            </div>

            <DataGrid
              onRowClick={(e) => openDataModal(e)}
              rows={
                AmpHoursZeroFilter
                  ? AmpHoursZeroFilterValue !== null && AmpHoursZeroFilterValue
                  : rows !== null && includeZeroAMPHoursRows
              }
              columns={[
                {
                  field: "CarNumber",
                  headerName: t("car"),
                  width: 180,
                  sortable: true,
                },
                {
                  field: "AmpHours",
                  headerName: t("Amp_Hours"),
                  width: 180,
                  sortable: true,
                },
              ]}
              pageSize={
                (AmpHoursZeroFilter
                  ? AmpHoursZeroFilterValue !== null &&
                  AmpHoursZeroFilterValue.length
                  : rows !== null && includeZeroAMPHoursRows.length) > 100 ? 100 : (AmpHoursZeroFilter
                    ? AmpHoursZeroFilterValue !== null &&
                    AmpHoursZeroFilterValue.length
                    : rows !== null && includeZeroAMPHoursRows.length)
              }
            />
            <div className="action-btn">
              <div>
                <input
                  type="checkbox"
                  onChange={(e) => includeZeroAmpHours(e)}
                />{" "}
                Include zeros
              </div>
              <button onClick={downloadFile}>{t("Download")}</button>
            </div>
          </div>
        </ChartRow>

        {/* Chart of AH per Mile */}
        <ChartRow>
          <div>
            {getCarUsageDetailState &&
              getCarUsageDetailState !== null &&
              getCarUsageDetailState !== undefined &&
              getCarUsageDetailState?.AverageAmpHoursPerMileDetails !== null ? (
              <Chart
                onRefresh={handleAMPHoursPerMilesChartRefresh}
                onSeriesClick={(e) => openDataModal(e)}
              >
                <ChartArea background="#fff" margin={0} />
                <ChartLegend visible={false} />
                <ChartTitle text={t("AH_per_Mile")} font="14pt sans-serif" />
                <ChartTooltip
                  border={{ color: "white" }}
                  background="green"
                  color="white"
                  shared={true}
                  render={sharedAHPerMileTooltipRender}
                  visible={true}
                />
                <ChartSeriesDefaults type="column" line={{ width: 1 }} />
                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    axisCrossingValue={0}
                    minorTicks={{ visible: false }}
                    labels={{ visible: false }}
                    field="CarNumber"
                  />
                </ChartCategoryAxis>
                <ChartValueAxis>
                  <ChartValueAxisItem
                    axisCrossingValue={0}
                    labels={{
                      color: "black",
                      format: "{0}",
                    }}
                    plotBands={[
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                            ?.RangeHigh,
                        to: 1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                            ?.RangeLow,
                        to: -1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                            ?.Average,
                        to:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                            ?.RangeHigh,
                        color: "green",
                        opacity: 0.2,
                      },
                      {
                        from:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                            ?.Average,
                        to:
                          getCarUsageDetailState &&
                          getCarUsageDetailState !== null &&
                          getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                            ?.RangeLow,
                        color: "green",
                        opacity: 0.2,
                      },
                    ]}
                    min={
                      AHPerMilesZeroFilter
                        ? aHPerMileZeroFilterData !== undefined &&
                        Math.min(
                          ...aHPerMileZeroFilterData.map(
                            (o) => o.AmpHoursPerMile
                          )
                        )
                        : ampHoursData !== undefined &&
                        Math.min(
                          ...ampHoursData.map((o) => o.AmpHoursPerMile)
                        )
                    }
                    max={
                      AHPerMilesZeroFilter
                        ? aHPerMileZeroFilterData !== undefined &&
                        Math.max(
                          ...aHPerMileZeroFilterData.map(
                            (o) => o.AmpHoursPerMile
                          )
                        )
                        : ampHoursData !== undefined &&
                        Math.max(
                          ...ampHoursData.map((o) => o.AmpHoursPerMile)
                        )
                    }
                    minorTicks={{ visible: false }}
                  />
                </ChartValueAxis>
                <ChartSeries>
                  <ChartSeriesItem
                    gap={0}
                    line={1}
                    field="AmpHoursPerMile"
                    name="AmpHoursPerMile"
                    color={(e) =>
                      e.value >
                        getCarUsageDetailTempState
                          ?.AverageAmpHoursPerMileDetails?.RangeHigh ||
                        e.value <
                        getCarUsageDetailTempState
                          ?.AverageAmpHoursPerMileDetails?.RangeLow ||
                        (getCarUsageDetailTempState?.AverageAmpHoursPerMileDetails
                          ?.RangeLow === 0 &&
                          e.value === 0)
                        ? "red"
                        : "green"
                    }
                    data={
                      AHPerMilesZeroFilter
                        ? aHPerMileZeroFilterData !== undefined &&
                        aHPerMileZeroFilterData.sort(
                          (a, b) => a.AmpHoursPerMile - b.AmpHoursPerMile
                        )
                        : ampHoursData !== undefined &&
                        ampHoursData.sort(
                          (a, b) => a.AmpHoursPerMile - b.AmpHoursPerMile
                        )
                    }
                  />
                  <ChartSeriesItem
                    type="line"
                    style="smooth"
                    name="Average"
                    color="black"
                    markers={{
                      visible: false,
                    }}
                    data={AHPerMileAverageData}
                  />
                </ChartSeries>
              </Chart>
            ) : (
              <>
                <strong>{t("AH_per_Mile")}</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
          <div>
            <div className="heading">
              <div>
                {t("Average")}:{" "}
                {AHPerMilesZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                    ?.Average
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState
                    ?.AverageAmpHoursPerMileDetailsIncludesZero?.Average}{" "}
              </div>
              <div>
                {t("Range")}:{" "}
                {AHPerMilesZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                    ?.RangeLow
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState
                    ?.AverageAmpHoursPerMileDetailsIncludesZero
                    ?.RangeLow}{" "}
                -{" "}
                {AHPerMilesZeroFilter
                  ? getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState?.AverageAmpHoursPerMileDetails
                    ?.RangeHigh
                  : getCarUsageDetailState &&
                  getCarUsageDetailState !== null &&
                  getCarUsageDetailState
                    ?.AverageAmpHoursPerMileDetailsIncludesZero
                    ?.RangeHigh}{" "}
              </div>
              <div>{t("Cars_outside_range")}</div>
            </div>
            <DataGrid
              onRowClick={(e) => openDataModal(e)}
              rows={
                AHPerMilesZeroFilter
                  ? AHPerMilesZeroFilterValue !== null &&
                  AHPerMilesZeroFilterValue
                  : rows !== null && includeZeroAHPerMilesRows
              }
              columns={[
                {
                  field: "CarNumber",
                  headerName: t("car"),
                  width: 180,
                  sortable: true,
                },
                {
                  field: "AmpHoursPerMile",
                  headerName: t("AH_Mile"),
                  width: 180,
                  sortable: true,
                },
              ]}
              pageSize={
                (AHPerMilesZeroFilter
                  ? AHPerMilesZeroFilterValue !== null &&
                  AHPerMilesZeroFilterValue.length
                  : rows !== null && includeZeroAHPerMilesRows.length) > 100 ? 100 : (AHPerMilesZeroFilter
                    ? AHPerMilesZeroFilterValue !== null &&
                    AHPerMilesZeroFilterValue.length
                    : rows !== null && includeZeroAHPerMilesRows.length)
              }
            />

            <div className="action-btn">
              <div>
                <input
                  type="checkbox"
                  onChange={(e) => includeZeroAHPerMiles(e)}
                />{" "}
                Include zeros
              </div>
              <button onClick={downloadFile}>{t("Download")}</button>
            </div>
          </div>
        </ChartRow>

        {/* Chart of Round and Hole */}
        {/* Changes needs to be applied here */}
        <ChartRow>
          <div>
            {(getRoundsByCarDetailState &&
              getRoundsByCarDetailState !== null &&
              getRoundsByCarDetailState !== undefined &&
              getRoundsByCarDetailState?.AverageHoleDetails !== null) ||
              (getRoundsByCarDetailState &&
                getRoundsByCarDetailState !== null &&
                getRoundsByCarDetailState !== undefined &&
                getRoundsByCarDetailState?.AverageRoundDetails !== null) ? (
              <Chart
                onRefresh={handleRoundHoleChartRefresh}
                onSeriesClick={(e) => openDataModal(e)}
              >
                <ChartArea background="#fff" margin={0} />
                <ChartLegend visible={false} />
                <ChartTitle
                  text={roundStateGlobal.get() ? t("Rounds") : t("Holes")}
                  font="14pt sans-serif"
                />
                <ChartTooltip
                  border={{ color: "transparent" }}
                  background="transparent"
                  color="white"
                  shared={true}
                  render={sharedRoundTooltipRender}
                  visible={true}
                />
                <ChartSeriesDefaults type="column" line={{ width: 1 }} />
                <ChartCategoryAxis>
                  <ChartCategoryAxisItem
                    axisCrossingValue={0}
                    minorTicks={{ visible: false }}
                    labels={{ visible: false }}
                    field="CarNumber"
                  />
                </ChartCategoryAxis>
                <ChartValueAxis>
                  <ChartValueAxisItem
                    axisCrossingValue={0}
                    labels={{
                      color: "black",
                      format: "{0}",
                    }}
                    plotBands={[
                      {
                        from: rangeHighRounds,
                        to: 1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from: rangeLowRounds,
                        to: -1000000,
                        color: "red",
                        opacity: 0.1,
                      },
                      {
                        from: averageRounds,
                        to: rangeHighRounds,
                        color: "green",
                        opacity: 0.2,
                      },
                      {
                        from: averageRounds,
                        to: rangeLowRounds,
                        color: "green",
                        opacity: 0.2,
                      },
                    ]}
                    min={roundsMin}
                    max={roundsMax}
                    minorTicks={{ visible: false }}
                  />
                </ChartValueAxis>
                <ChartSeries>
                  <ChartSeriesItem
                    gap={0}
                    line={1}
                    field={roundStateGlobal.get() ? "Rounds" : "Holes"}
                    name={roundStateGlobal.get() ? "Rounds" : "Holes"}
                    color={(e) => {
                      if (
                        getRoundsByCarDetailState &&
                        Object.keys(getRoundsByCarDetailState).length > 0
                      ) {
                        if (
                          e.value > rangeHighRounds ||
                          e.value < rangeLowRounds ||
                          (rangeLowRounds === 0 && e.value === 0)
                        ) {
                          return "red";
                        } else {
                          return "green";
                        }
                      }
                    }}
                    data={
                      roundStateGlobal.get()
                        ? GetRoundsByCarTable &&
                        GetRoundsByCarTable !== undefined &&
                        GetRoundsByCarTable.sort(
                          (a, b) => a.Rounds - b.Rounds
                        )
                        : GetRoundsByCarTable &&
                        GetRoundsByCarTable !== undefined &&
                        GetRoundsByCarTable.sort((a, b) => a.Holes - b.Holes)
                    }
                  />

                  <ChartSeriesItem
                    type="line"
                    style="smooth"
                    name="Average"
                    color="black"
                    markers={{
                      type: "circle",
                      visible: false,
                      rotation: 0,
                      size: 5,
                      background: "black",
                      border: "black",
                      borderRadius: 2,
                    }}
                    data={
                      roundStateGlobal.get()
                        ? roundAverageData
                        : holeAverageData
                    }
                  />
                </ChartSeries>
              </Chart>
            ) : roundStateGlobal.get() ? (
              <>
                <strong>{t("Round")}</strong>
                <br />
                {t("No_data")}
              </>
            ) : (
              <>
                <strong>Holes</strong>
                <br />
                {t("No_data")}
              </>
            )}
          </div>
          <div>
            <div className="heading">
              <div>
                {t("Average")}:{" "}
                {roundStateGlobal.get()
                  ? getRoundsByCarDetailState &&
                  getRoundsByCarDetailState?.AverageRoundDetails?.Average
                  : getRoundsByCarDetailState &&
                  getRoundsByCarDetailState?.AverageHoleDetails?.Average}{" "}
              </div>
              <div>
                {t("Range")}: {rangeLowRounds !== 0 && rangeLowRounds}-{" "}
                {rangeHighRounds !== 0 && rangeHighRounds}
              </div>
              <div>{t("Cars_outside_range")}</div>
            </div>
            {roundStateGlobal.get() ? ((filteredRangeData !== undefined && filteredRangeData != null) ?
              <DataGrid
                rows={filteredRangeData !== null && filteredRangeData}
                onRowClick={(e) => openDataModal(e)}
                columns={[
                  {
                    field: "Car",
                    headerName: "Car",
                    width: 180,
                    sortable: true,
                  },
                  {
                    field: "Rounds",
                    headerName: "Rounds",
                    width: 180,
                    sortable: true,
                  },
                ]}
                pageSize={filteredRangeData.length > 100 ? 100 : filteredRangeData.length}
              /> : <></>
            ) : ((avarageRoundDataValue !== undefined && avarageRoundDataValue != null) ?
              <DataGrid
                rows={avarageRoundDataValue !== null && avarageRoundDataValue}
                onRowClick={(e) => openDataModal(e)}
                columns={[
                  {
                    field: "Car",
                    headerName: t("car"),
                    width: 180,
                    sortable: true,
                  },
                  {
                    field: "Holes",
                    headerName: t("Holes"),
                    width: 180,
                    sortable: true,
                  },
                ]}
                pageSize={avarageRoundDataValue.length > 100 ? 100 : avarageRoundDataValue.length}
              />
              : <></>)}
          </div>
        </ChartRow>

        {TempCarObj !== null && TempCarObj !== undefined ? (
          <>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <CarDetails
                  carInformation={TempCarObj}
                  handleClick={handleClick}
                  paceString={paceString}
                />
              </Box>
            </Modal>
            <Modal
              open={isLoading.get()}
              onClose={handleClose2}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style2}>
                <MsgToSelectedCarsCmp cancelClick={handleClose2} />
              </Box>
            </Modal>
          </>
        ) : (
          ""
        )}
        <Modal
          open={openCarNotFound}
          onClose={() => setOpenCarNotFound(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style3}>
            <PopUpContainer>
              <h4>{`Car ${clickedCarNumber} not found`}</h4>
              <div className="action-btn">
                <button
                  className="primary"
                  onClick={() => setOpenCarNotFound(false)}
                >
                  {t("Ok")}
                </button>
              </div>
            </PopUpContainer>
          </Box>
        </Modal>

        <SortingHeader ref={filterH}>
          <div className="date-range-wrapper">
            <div className="label-wrapper">
              <label name="start">{t("Start")}</label>
              {/* <input value={startDate} onChange={(e) => startDateChange(e)} type="date" /> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  name="start"
                  inputFormat="DD-MMM-YYYY"
                  // views={["day", "month", "year"]}
                  label=""
                  value={startDate}
                  onChange={(newValue) => {
                    setStartDate(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </div>
            <div className="label-wrapper">
              <label name="End">{t("End")}</label>
              {/* <input value={endDate} onChange={(e) => endDateChange(e)} type="date" /> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  name="End"
                  inputFormat="DD-MMM-YYYY"
                  // views={["day", "month", "year"]}
                  label=""
                  value={endDate}
                  onChange={(newValue) => {
                    setEndDate(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </div>
          </div>
          <div className="btn-header-wrapper">
            <CircleBtn
              onClick={() => {
                holeStateGlobal.set(false);
                roundStateGlobal.set(true);
              }}
              style={roundStateGlobal.get() ? activeBtn : null}
            >
              {t("Rounds")}
            </CircleBtn>
            <CircleBtn
              onClick={() => {
                holeStateGlobal.set(true);
                roundStateGlobal.set(false);
              }}
              style={holeStateGlobal.get() ? activeBtn : null}
            >
              Holes
            </CircleBtn>

            <CircleBtn
              style={MtdState ? activeBtn : null}
              onClick={showMonthlyData}
            >
              MTD
            </CircleBtn>
            <CircleBtn
              style={QtdState ? activeBtn : null}
              onClick={showQuaterlyData}
            >
              QTD
            </CircleBtn>
            <CircleBtn
              style={YTDState ? activeBtn : null}
              onClick={showYearlyData}
            >
              YTD
            </CircleBtn>
            <CircleBtn onClick={RounddownloadFile}>{t("Download")}</CircleBtn>
            <CircleBtn onClick={refreshFunc}>{t("Refresh")}</CircleBtn>
          </div>
        </SortingHeader>
      </UsageContainer>
    </Wrapper>
  );
});

export default UsageReport;
